import AddIcon from '@mui/icons-material/Add';
import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

import { useDocumentMedia } from '../../libs/utils/document';
import { solidButtonSx } from '../BatchTracking/dashboardTokens';

type AddOption = { label: string; onSelect: () => void };

// What a person can record from Home; the button is the plus alone on a phone. One option opens at once, two or more open a menu.
const AddMenu = ({ options }: { options: AddOption[] }) => {
  const { isMobile } = useDocumentMedia();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [only] = options;
  const direct = options.length === 1 ? only : undefined;

  return (
    <>
      <Button
        variant="contained"
        aria-label="Add"
        {...(direct ? {} : { 'aria-haspopup': 'menu', 'aria-expanded': anchor !== null })}
        sx={{
          ...solidButtonSx,
          ...(isMobile ? { width: 48, height: 48, minWidth: 48, px: 0 } : { height: 44, pl: 1.75, pr: 2.25 })
        }}
        onClick={(event) => (direct ? direct.onSelect() : setAnchor(event.currentTarget))}
      >
        <AddIcon sx={{ fontSize: 22, mr: isMobile ? 0 : 0.75 }} />
        {!isMobile && 'Add'}
      </Button>
      {!direct && (
        <Menu anchorEl={anchor} open={anchor !== null} onClose={() => setAnchor(null)}>
          {options.map(({ label, onSelect }) => (
            <MenuItem
              key={label}
              onClick={() => {
                setAnchor(null);
                onSelect();
              }}
            >
              {label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default AddMenu;
